const INSTANCE_ENDPOINTS = {
  BASE: '/instances',
  BY_ID: (id: string) => `/instances/${id}`,
  REGISTRATION_KEYS: (instanceId: string) => `/instances/${instanceId}/registration-keys`,
  REGISTRATION_KEY_BY_ID: (instanceId: string, keyId: string) =>
    `/instances/${instanceId}/registration-keys/${keyId}`,
  TERRAINS: '/terrains',
};

export default INSTANCE_ENDPOINTS;
